import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logo from '../../assets/image/logo.png';
import HeroSection from './HeroSection';
import CounterSection from './CounterSection';
import MSMEStatsSection from './MSMEStatsSection';
import BenefitsSection from './BenefitsSection';
import BonusesSection from './BonusesSection';
import AboutSection from './AboutSection';
import PricingSection from './PricingSection';
import FooterSection from './FooterSection';
import PaymentModal from './PaymentModal';
import PaymentPage from './PaymentPage';
import VideoTestimonialsSection from '../CreditControl/VideoTestimonialsSection';
import ResultsSection from '../CreditControl/ResultsSection';
import TestimonialsSection from '../BlockedPayments/TestimonialsSection';
import ContactSection from './ContactSection';
import FinalCTASection from './FinalCTASection';
import EnrollCTASection from './EnrollCTASection';

const CallingScripts = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [showPaymentPage, setShowPaymentPage] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState(2975);
  const [pricing, setPricing] = useState({
    price1Friend: 2975,
    price2Friends: 2975,
    originalPrice: 7000,
    enable2Friends: true
  });
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_PAYMENT_API_URL || 'http://localhost:5005/api';

  // Fetch pricing from admin panel
  const fetchPricing = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/payments/page-pricing/active/calling-scripts`);
      const data = await response.json();
      if (data.success && data.pricing) {
        setPricing({
          price1Friend: parseFloat(data.pricing.price_1_friend) || 2975,
          price2Friends: parseFloat(data.pricing.price_2_friends) || 2975,
          originalPrice: 7000,
          enable2Friends: data.pricing.enable_2_friends !== false
        });
      }
    } catch (err) {
      console.error('Failed to fetch pricing:', err);
    }
  }, [API_BASE_URL]);

  useEffect(() => {
    fetchPricing();
  }, [fetchPricing]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openPaymentModal = () => {
    setIsPaymentModalOpen(true);
  };

  const closePaymentModal = () => {
    setIsPaymentModalOpen(false);
  };

  const handleOpenPaymentPage = (price) => {
    setSelectedPrice(price || pricing.price1Friend);
    setShowPaymentPage(true);
    document.body.style.overflow = 'hidden';
  };

  const handleClosePaymentPage = () => {
    setShowPaymentPage(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Sticky Header */}
      <header 
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isScrolled 
            ? 'bg-black/95 backdrop-blur-md shadow-2xl shadow-amber-500/10 py-3' 
            : 'bg-transparent py-5'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center space-x-3 group">
              <div className="w-14 h-14 bg-white rounded-xl p-1 shadow-lg shadow-amber-500/20 group-hover:shadow-amber-500/40 transition-all duration-300 group-hover:scale-105">
                <img 
                  src={logo} 
                  alt="Rushneek Singh" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="hidden sm:block">
                <h1 className="text-xl font-bold bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent">
                  Rushneek Singh
                </h1>
                <p className="text-xs text-gray-400">India's No. 1 B2B Payment Recovery Coach</p>
              </div>
            </div>
            

          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>
        <HeroSection onOpenPaymentPage={handleOpenPaymentPage} pricing={pricing} />
        <CounterSection onBuyClick={() => handleOpenPaymentPage(pricing.price1Friend)} />
        <EnrollCTASection onOpenPaymentPage={handleOpenPaymentPage} price={pricing.price1Friend} />
        {/* <MSMEStatsSection /> */}
        <BenefitsSection />
        <EnrollCTASection onOpenPaymentPage={handleOpenPaymentPage} price={pricing.price1Friend} />
        <AboutSection />
        <EnrollCTASection onOpenPaymentPage={handleOpenPaymentPage} price={pricing.price1Friend} />
        <BonusesSection />
        <EnrollCTASection onOpenPaymentPage={handleOpenPaymentPage} price={pricing.price1Friend} />
        <TestimonialsSection/>
        <EnrollCTASection onOpenPaymentPage={handleOpenPaymentPage} price={pricing.price1Friend} />
        <VideoTestimonialsSection onBuyClick={() => handleOpenPaymentPage(pricing.price1Friend)} />
        {/* <EnrollCTASection onOpenPaymentPage={handleOpenPaymentPage} price={pricing.price1Friend} /> */}
        {/* <FinalCTASection onOpenPaymentPage={handleOpenPaymentPage} pricing={pricing} /> */}
        {/* <EnrollCTASection onOpenPaymentPage={handleOpenPaymentPage} price={pricing.price1Friend} /> */}
        <PricingSection onOpenPaymentPage={handleOpenPaymentPage} pricing={pricing} />
          <PaymentModal 
        isOpen={isPaymentModalOpen}
        onClose={closePaymentModal}
        amount={pricing.price1Friend}
        productName="B2B Payment Recovery Calling Scripts"
      />
        {/* <EnrollCTASection onOpenPaymentPage={handleOpenPaymentPage} price={pricing.price1Friend} /> */}
        <ContactSection />
        <FooterSection />
      </main>

      {/* Payment Page */}
      {showPaymentPage && (
        <PaymentPage 
          isOpen={showPaymentPage}
          selectedPrice={selectedPrice}
          onClose={handleClosePaymentPage}
        />
      )}
    
    </div>
  );
};

export default CallingScripts;
